/*
 * Copyright 2025 Intuition Robotics ltd
 */
import {Checkbox} from "../patients/Checkbox";
import {FONTS} from "@res/fonts";
import {
	hideTooltip,
	showTooltip
} from "../../widget/appTooltip";
import * as React from "react";
import {CSSProperties} from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import * as emotion from "emotion";
import {DefaultResponses} from "@app/app-shared/message";
import {IconInfo} from "../../widget/IconInfo";
import {COLORS} from "@res/colors";

const chatBoxCheckbox = emotion.css(
	{
		backgroundColor: "white",
		borderRadius: 2,
		marginRight: 10
	}
);

export class RequireResponseTooltip
	extends BaseComponent<{}, {}> {
	render() {
		return <div className={`ll_v_l`} style={{padding: "14px 16px"}}>
			<div style={{marginBottom: 5}}>
				{FONTS.reg_14("Recipients will be able to reply with one of the following options:")}
			</div>
			{
				DefaultResponses.map((response, i) => {
					return <div key={response} className={"ll_h_c"} style={{
						marginBottom: (i !== DefaultResponses.length - 1 ? 3 : undefined)
					}}>
						<div style={{marginRight: 2}}>
							{FONTS.reg_14(`${i + 1}.`)}
						</div>
						<div>
							{FONTS.reg_14(response)}
						</div>
					</div>;
				})
			}
		</div>;
	}
}

type RequestPatientResponseProps = {
	requireResponse: boolean;
	onChange: (on: boolean) => void;
	text: string;
	tooltipStyle?: CSSProperties
	disabled?: boolean;
}

type RequestPatientResponseState = {}

export class RequestPatientResponse
	extends BaseComponent<RequestPatientResponseProps, RequestPatientResponseState> {

	constructor(props: RequestPatientResponseProps) {
		super(props);
	}

	render() {
		return <div className={"ll_h_c"}>
			<div className={`${chatBoxCheckbox}`}>
				<Checkbox on={this.props.requireResponse} onChange={(e) => {
					if (this.props.disabled) {
						return;
					}
					this.props.onChange(e);
				}}/>
			</div>
			{FONTS.reg_14(this.props.text, {marginRight: 8})}
			<IconInfo
				onMouseOver={(e) => {
					const rect = e.currentTarget.getBoundingClientRect();
					showTooltip(e, <RequireResponseTooltip/>,
					            rect.left,
					            rect.top,
					            {
						            zIndex: 9999,
						            textAlign: "left",
						            backgroundColor: "white",
						            borderRadius: "4px",
						            transform: "translate(-100%, -100%)",
						            width: 340,
						            border: `1px solid ${COLORS.primary_light_blue}`,
						            ...this.props.tooltipStyle
					            });
				}}
				onMouseLeave={(_e) => {
					hideTooltip();
					return;
				}}
			/>
		</div>;
	}

}

